import { Measure, VisionFilterKey, VisionKey } from '@wizeoo/akm-message-lib';
import { WizConstants } from "../../model/constants";


/**
 * une clé utilisable dans les widgets
 * c'est soit une visionKey, une filterKey ou une measure
 * Permet de choisir quoi mettre où
 */
export class FeiKeyDef {

  public measure: Measure = null;
  public visionKey: VisionKey = null;
  public visionFilterKey: VisionFilterKey = null;

  public isMeasure: boolean = false; // une mesure
  public isKey: boolean = false; // une visionKey ou une visionFilterKey
  public isFilterKey: boolean = false; // une visionFilterKey
  public isFreedata: boolean = false; // un Freedata, pour gestion éventuelle du champ de rendu
  public isChrono: boolean = false; // un chrono, pour gestion éventuelle du champ de rendu
  public isScen: boolean = false; // c'est la clé qui correspond au scenario
  public isSequence: boolean = false; // une clé de type FD de nature séquence

  public code: string; // le code exact de la data, sans level ni mode
  public mode: string = null; // mode FIST pour les measures
  public level: number = 0; // niveau pour les keys & filters

  public fullCode: string; // le code complet (avec #mode pour les measures) ou #level pour le reste
  public datakind: string; // le type de données, FIELD_KIND précis (Int, Number, Date, Bool, String)

  public nbDecimal: number = 0; // nombre de décimales (pour les mesures)
 
  public indexInKey: number = -1; // l'indice de position de cette clé dans la construction des clés (indice de la visionKey - 1)

  // #######################################
  // ###  paramètres IHM
  // #######################################
  
  public visible: boolean = true; // colonne visible
  public pinned: string = null; // champ verrouillé à gauche ('left')
  public sortable: boolean = false; // triable

  public width: number = 120; // taille demandée
  public minWidth: number = 20; // taille min

  public editable: boolean = false; // éditable ? (I sans formula ou FilterKey)
  public calculated: boolean = false; // marquer les lignes I calculées, pour refresh massif, alimenté par le FeiVO lors de la construction des clés
  public sortKey: number = 0; // clé pour tri dans les listes : Key / filter / measures

  // pour construction des colonnes de grid / rendu des champs
  public label: string = null; // libellé
  public order: number = 0; // L'ordre souhaité pour les colonnes
  public deleteField: boolean = false; // champ spécifique pour gestion des suppressions
  public selectField: boolean = false; // champ spécifique pour gestion de la colonne de sélection
  public defaultFormat: string = null; // format défini sur la mesure
  public defaultStyle: string = null; // style défini sur la mesure

  // pour gestion des ToolsPivot, mode IncludeExclude
  public incexcField: boolean = false;
  // pour gestion des ToolsPivot, mode VisionStepPerimeter
  public vspField: boolean = false;
  // pour gestion des ToolsPivot, mode rendu de mesure liste
  public listField: boolean = false;

  // #######################################
  // ### gestion des paramètres pour les popUp de configuration
  // #######################################
  
  /**
   * alimentation des paramètres de visibilité IHM
   * @param visible 
   * @param sortable 
   * @param pinned fixé à gauche dans les grids
   */
  public setParams(visible: boolean = true, sortable: boolean = false, pinned: string = null): FeiKeyDef {
    this.visible = visible;
    this.sortable = sortable;
    this.pinned = pinned;
    return this;
  }

  /**
   * alimentation des tailles pour les champs
   * @param width ...
   * @param minWidth ...
   */
  public setSize(width: number = 120, minWidth: number = 120): FeiKeyDef {
    this.width = width;
    this.minWidth = minWidth;
    if (width < minWidth) {
      this.minWidth = width;
    }
    return this;
  }

  /** accesseur pour rendu dans la pop d'édition. Affiche fx sur les mesures non éditables */
  public get isFormula(): boolean {
    return this.isMeasure && !this.editable;
  }

  /** accesseur sur la formule de calcul */
  public get formula(): string {
    return this.measure?.formulaI;
  }

  /** formule mode I */
  public get isI(): boolean {
    return this.mode === WizConstants.MEASURE_MODE_INTERACT;
  }

  /** formule mode S */
  public get isS(): boolean {
    return this.mode === WizConstants.MEASURE_MODE_SUBMIT;
  }

  /** formule mode T */
  public get isT(): boolean {
    return this.mode === WizConstants.MEASURE_MODE_TO;
  }

  /** formule mode F */
  public get isF(): boolean {
    return this.mode === WizConstants.MEASURE_MODE_FROM;
  }

}
